"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processCustomFilters = exports.processCustomFields = exports.executeSearch = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _debug = _interopRequireDefault(require("debug"));
var _ANGAssetHighlightAdapter = _interopRequireDefault(require("@mulesoft/exchange-assets-definitions/lib/rest-api/adapters/ANGAssetHighlightAdapter"));
var _exchangeSearchCommon = require("@mulesoft/exchange-search-common");
var _types = require("../types");
var _ANGFactory = _interopRequireDefault(require("./ANGFactory"));
var _types2 = require("./types");
var _utils = require("../CustomFieldsFilter/utils");
var _date = require("./date");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const log = (0, _debug.default)('exchange:search:utils');
const SEARCH_QUERY_CHANGED_CODE = 2;
const MAX_ANG_STREAM_BATCH_RESULTS = 20;
const CUSTOM_FIELDS_FILTER_KEY = 'CustomFieldsFilter';
function replaceAssetTypes(state, fixedTypes, assetTypesConfiguration, featureFlags) {
  const selectedTypes = state.filters[_exchangeSearchCommon.constants.TYPE_KEY];
  if (selectedTypes && selectedTypes.length > 0) {
    return state;
  }
  let allANGTypes;
  if (fixedTypes.length) {
    allANGTypes = (0, _exchangeSearchCommon.getANGTypes)(fixedTypes, assetTypesConfiguration);
  } else {
    allANGTypes = (0, _types2.getAllANGTypes)(assetTypesConfiguration, featureFlags);
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    filters: _objectSpread(_objectSpread({}, state.filters), {}, {
      [_exchangeSearchCommon.constants.TYPE_KEY]: allANGTypes
    })
  });
}
const isDateDataType = filter => {
  // this is a special case where user sets a custom field with a date by param in the URL
  // and we need to fetch facets for that but we still don't know what the data types are
  if (!filter.customField) {
    // we do then a best effort for it and we try to guess if this is a date
    // and if so, then we return "Date" as the date type 🤪
    return (0, _date.isDateInput)(filter.value);
  }
  return filter.customField.dataType === _types.FacetsCustomFieldType.Date;
};

/**
 * Process dates queries and do transformations according to this chart:
 * {@link https://gist.github.com/nescalante/1e417a0eed8457f3f009ef3d87adf228}
 *
 * @param values
 * @param facets
 */
const processCustomFields = (values, facets) => {
  const transformedValues = values.reduce((accum, value) => {
    const filter = (0, _utils.parseFilter)(value, facets === null || facets === void 0 ? void 0 : facets.fields);
    const defaultResult = [...accum, value];
    if (!filter) {
      // we should never come into to this state, but just in case
      return defaultResult;
    }
    if (isDateDataType(filter)) {
      // getting day starting time and final time that will be used to create
      // operations based on the gist added above
      const {
        tagKey
      } = filter;
      const date = (0, _date.decomposeDate)(filter.value);
      const finalKey = filter.key ? `:${filter.key}` : '';
      return [...accum, `${tagKey}:${date}${_date.GMT_TIME_ZONE}:${filter.operator}${finalKey}`];
    }
    return defaultResult;
  }, []);
  return transformedValues;
};
exports.processCustomFields = processCustomFields;
const processCustomFilters = (angState, facets) => {
  var _customFieldsFilter$, _customFieldsFilter$2;
  const {
    customFilters
  } = angState;
  const customFieldsFilter = customFilters === null || customFilters === void 0 ? void 0 : customFilters[CUSTOM_FIELDS_FILTER_KEY];
  const values = (_customFieldsFilter$ = customFieldsFilter === null || customFieldsFilter === void 0 || (_customFieldsFilter$2 = customFieldsFilter[0]) === null || _customFieldsFilter$2 === void 0 ? void 0 : _customFieldsFilter$2.values) !== null && _customFieldsFilter$ !== void 0 ? _customFieldsFilter$ : [];
  if (values.length === 0) {
    var _angState$customFilte;
    return (_angState$customFilte = angState.customFilters) !== null && _angState$customFilte !== void 0 ? _angState$customFilte : {};
  }
  const transformedValues = processCustomFields(values, facets);
  const fieldsKey = customFieldsFilter === null || customFieldsFilter === void 0 ? void 0 : customFieldsFilter[0].key;
  return _objectSpread(_objectSpread({}, customFilters), {}, {
    [CUSTOM_FIELDS_FILTER_KEY]: [_objectSpread(_objectSpread({}, customFieldsFilter), {}, {
      key: fieldsKey,
      values: transformedValues
    })]
  });
};
exports.processCustomFilters = processCustomFilters;
const executeSearch = ({
  angConfig,
  authorization,
  angState,
  assetTypesConfiguration,
  featureFlags,
  fixedTypes,
  onBatchProcess,
  onFinish
}) => {
  const queryController = _ANGFactory.default.createQueryController(angConfig, authorization, replaceAssetTypes(angState, fixedTypes, assetTypesConfiguration, featureFlags));
  const queryExecutor = _ANGFactory.default.createQueryExecutor();
  let batchNumber = 0;
  let batchedAssets = [];
  const processBatch = () => {
    onBatchProcess(batchedAssets, batchNumber);
    batchedAssets = [];
    batchNumber += 1;
  };
  log('executing search', angState, angConfig);
  return new Promise((resolve, reject) => {
    queryExecutor.execute(queryController, {
      onFailure: ({
        data,
        status
      }) => {
        const error = new _types.HTTPError(data, status);
        reject(error);
      },
      onFinish: reason => {
        const isSearchCancelled = (reason === null || reason === void 0 ? void 0 : reason.code) === SEARCH_QUERY_CHANGED_CODE;
        if (!isSearchCancelled) {
          if (batchedAssets.length) {
            processBatch();
          }
          onFinish();
        }
        resolve(null);
      },
      onSearch: () => {},
      onStart: () => {},
      onHit: hit => {
        const assetAdapter = new _exchangeSearchCommon.ANGAssetAdapter(hit, assetTypesConfiguration);
        const asset = assetAdapter.parse();
        // TODO: support search definitions by importing from assets-definitions
        // in the mean time, we have the rest-api adapter hardcoded here since by now
        // its the only adapter extended
        const ANGAssetHighlightAdapter = asset.type === 'rest-api' ? _ANGAssetHighlightAdapter.default : _exchangeSearchCommon.ANGAssetHighlightAdapter;
        const highlightAdapter = new ANGAssetHighlightAdapter(_objectSpread(_objectSpread({}, hit), {}, {
          searchTerm: angState === null || angState === void 0 ? void 0 : angState.query
        }));
        const highlight = highlightAdapter.parse();
        log('asset from ANG', hit);
        log('converted asset', asset);
        log('highlight', highlight);
        batchedAssets.push([asset, highlight]);
        if (batchedAssets.length >= MAX_ANG_STREAM_BATCH_RESULTS) {
          processBatch();
        }
      }
    });
  });
};
exports.executeSearch = executeSearch;
//# sourceMappingURL=search.js.map